<template>
  <!--    表格部分-->
  <div>
    <vxe-table
        border
        ref="tableDataId"
        align="center"
        :data="tableData">
      <vxe-table-column
          v-for="(item,index) in list"
          :key="item.key"
          :field="item.val"
          :title="item.name"
      >
      </vxe-table-column>

    </vxe-table>
  </div>
</template>

<script>
export default {
  name: "print",
  props: {
    tableTd: {
      type: Array,
      default: []
    },
    tableTh: {
      type: Array,
      default: []
    },
    tableData: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      list: [],
    }
  },
  created() {
  },
  methods: {
    prints() {
      this.list = [];
      this.tableTh.map((res, index) => {
        let obj = {};
        obj.name = res;
        obj.val = this.tableTd[index]
        this.list.push(obj)
      })
    },
    print() {
      this.$refs.tableDataId.print()
    }
  }
};
</script>

<style media="print" lang="scss">
@page {
  size: auto;
  margin: 3mm;
}

@media print {
  html {
    background-color: #ffffff;
    height: auto;
    // margin: 0px;
  }

  body {
    border: solid 1px #ffffff;
    margin: 10mm 15mm 10mm 15mm;
  }

  #printData .el-table__header-wrapper .el-table__header {
    width: 99% !important;
    color: #000000;
  }
  #printData .el-table__body-wrapper .el-table__body {
    width: 99% !important;
    color: #606266;
  }
  #printData table {
    table-layout: fixed !important;
    margin: 0 auto;
  }
  .hidden {
    display: none;
  }
}
</style>
